{ /* Generated by Copilot- Start - 2026-04-02 17:14:40 */ }
import React from "react";
import Skeleton from "@mui/material/Skeleton";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvDivider from "@directv-digital/dds.ui.dtv-divider";

interface ModalPackageSectionSkeletonProps {
  /** Number of package row skeletons to render (default: 2) */
  itemCount?: number;
  /** Whether to show a divider above this skeleton section */
  showDivider?: boolean;
  /** Top margin when no divider (default: '26px') */
  topMargin?: string;
}

/**
 * Skeleton placeholder for ModalPackageSection.
 * Mirrors the exact layout and spacing of the real component:
 *   - Heading row (subhead2 ~20px)
 *   - N package rows, each with:
 *       left block: displayLabel (~20px tall) + packageLegal (~16px tall)
 *       right block: CTA button pill (36px tall, ~100px wide)
 * Uses MUI Skeleton wave animation (pulse effect).
 *
 * Used in MovieModalV2 while enrichment fetch + usePackageMatching are in-flight.
 */
const ModalPackageSectionSkeleton: React.FC<ModalPackageSectionSkeletonProps> = ({
  itemCount = 2,
  showDivider = false,
  topMargin = "26px"
}) => (
    <DtvBox
      sx={{
        mt: showDivider ? "0px" : topMargin,
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Divider — mirrors ModalPackageSection showDivider logic */}
      {showDivider && <DtvDivider sx={{ my: "16px" }} />}

      {/* Heading skeleton — matches DtvText variant="subhead2" fontSize 20px */}
      <Skeleton
        animation="wave"
        variant="text"
        width="60%"
        sx={{
 fontSize: "20px",
mb: "16px",
borderRadius: "4px"
}}
      />

      {/* Package row skeletons — each mirrors one PackageInfoCtaV2 row */}
      <DtvBox sx={{
 display: "flex",
flexDirection: "column",
gap: "12px"
}}>
        {Array.from({ length: itemCount }).map((_, i) => (
          <DtvBox
            key={i}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              justifyContent: {
 xs: "space-between",
sm: "flex-start"
}
            }}
          >
            {/* Left block: displayLabel + packageLegal text */}
            <DtvBox sx={{
 minWidth: {
 xs: "224px",
sm: "310px"
},
display: "flex",
flexDirection: "column",
gap: "4px"
}}>
              {/* displayLabel — matches body1medium fontSize 20px */}
              <Skeleton animation="wave" variant="text" width="55%" sx={{
 fontSize: "20px",
borderRadius: "4px"
}} />
              {/* packageLegal — matches body2 fontSize 16px */}
              <Skeleton animation="wave" variant="text" width="70%" sx={{
 fontSize: "16px",
borderRadius: "4px"
}} />
            </DtvBox>

            {/* Right block: CTA button pill — matches DtvButton height 36px */}
            <Skeleton
              animation="wave"
              height={36}
              variant="rounded"
              width={100}
              sx={{
 borderRadius: "18px",
flexShrink: 0,
alignSelf: "center"
}}
            />
          </DtvBox>
        ))}
      </DtvBox>
    </DtvBox>
);

export default React.memo(ModalPackageSectionSkeleton);
{ /* Generated by Copilot- End - 2026-04-02 17:14:40 */ }
